import styles from "./Skills.module.css";

const Skills = () => {
  return (
    <section className={`section`} id="skills">
      <h2 className="section__title">Skills</h2>
      <p className="section__subtitle">Minhas habilidades</p>
      <div className={`${styles.skills} container grid`}>
        <div className={`${styles.hard_skills_container}`}>
          <h3>Hard Skills</h3>
          <ul>
            <li>
              <i className="uil uil-check-circle"></i> HTML
            </li>
            <li>
              <i className="uil uil-check-circle"></i> CSS
            </li>
            <li>
              <i className="uil uil-check-circle"></i> JavaScript
            </li>
            <li>
              <i className="uil uil-check-circle"></i> React
            </li>
            <li>
              <i className="uil uil-check-circle"></i> C#
            </li>
            <li>
              <i className="uil uil-check-circle"></i> Firebase
            </li>
            <li>
              <i className="uil uil-check-circle"></i> Git
            </li>
            <li>
              <i className="uil uil-check-circle"></i> GitHub
            </li>
            <li>
              <i className="uil uil-check-circle"></i> Photoshop
            </li>
            <li>
              <i className="uil uil-check-circle"></i> Elementor
            </li>
          </ul>
        </div>
        <div>
          <h3>Soft Skills</h3>
          <ul>
            <li>
              <i className="uil uil-check-circle"></i> Resolução de conflitos
            </li>
            <li>
              <i className="uil uil-check-circle"></i> Proatividade
            </li>
            <li>
              <i className="uil uil-check-circle"></i> Capacidade analítica
            </li>
            <li>
              <i className="uil uil-check-circle"></i> Comunicação interpessoal
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Skills;
